module.exports = __webpack_public_path__ + "img/top.d1127d63.png";